import { useLocalStorage } from '@vueuse/core'
import { VISITOR_CODE, VISITOR_CODE_REFRESH_TIME } from '~/constants'

export function useVisitorCode(zoneCode: string) {
  return useLocalStorage(`${VISITOR_CODE}-${zoneCode}`, '', { flush: 'sync' })
}

export function useVisitorCodeRefreshTime(zoneCode: string) {
  return useLocalStorage(`${VISITOR_CODE_REFRESH_TIME}-${zoneCode}`, 0, { flush: 'sync' })
}
